import './Plugins';
import { trackPortalFormSubmission } from './tracking.ts';

angular.module('bizPartEngage').factory('bizFormTracking', () => trackPortalFormSubmission);
